import React from "react";
import { ImageLoader, LocationLoader, PropertyLoader, TitleLoader } from "./LoaderCommon";

export default function AgentLoader() {
    return (
        <div className="agent-card-inner agent_card_inner p-10">
            <div className="card_img agent_card_img">
                <ImageLoader />
            </div>
            <div className="agent_card_content agent_title">
                <h1 className="agent_name">
                    <TitleLoader />
                </h1>
                <div className="top_agent">
                    <div>
                        <PropertyLoader />
                    </div>
                    <div>
                        <PropertyLoader />
                    </div>
                    <div>
                        <PropertyLoader />
                    </div>
                    <div>
                        <PropertyLoader />
                    </div>
                </div>
                <div className="agent-details">
                    <LocationLoader />
                </div>
                <div className="agent-details pt-1">
                    <LocationLoader />
                </div>
                <div className="agent-actions p-0 pt-1">
                    <div>
                        <PropertyLoader />
                    </div>
                    <div>
                        <PropertyLoader />
                    </div>
                    <div>
                        <PropertyLoader />
                    </div>
                </div>
                <div className="agency_logo">
                    <PropertyLoader />
                </div>
            </div>
        </div>
    );
}
